
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b70"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b70"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eLX8K", function(module, exports) {

$parcel$export(module.exports, "BlurredEnvMapGenerator", () => $ac13547279de9cd0$export$13ef63fd7e562136);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");

var $9fZ6X = parcelRequire("9fZ6X");

var $dUUQZ = parcelRequire("dUUQZ");
class $ac13547279de9cd0$var$PMREMCopyMaterial extends (0, $9fZ6X.MaterialBase) {
    constructor(){
        super({
            uniforms: {
                envMap: {
                    value: null
                },
                blur: {
                    value: 0
                }
            },
            vertexShader: /* glsl */ `

				varying vec2 vUv;
				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}

			`,
            fragmentShader: /* glsl */ `

				#include <common>
				#include <cube_uv_reflection_fragment>

				${$dUUQZ.util_functions}

				uniform sampler2D envMap;
				uniform float blur;
				varying vec2 vUv;
				void main() {

					vec3 rayDirection = equirectUvToDirection( vUv );
					gl_FragColor = textureCubeUV( envMap, rayDirection, blur );

				}

			`
        });
    }
}
class $ac13547279de9cd0$export$13ef63fd7e562136 {
    constructor(renderer){
        this.renderer = renderer;
        this.pmremGenerator = new (0, $ilwiq.PMREMGenerator)(renderer);
        this.copyQuad = new (0, $RPVlj.FullScreenQuad)(new $ac13547279de9cd0$var$PMREMCopyMaterial());
        this.renderTarget = new (0, $ilwiq.WebGLRenderTarget)(1, 1, {
            type: (0, $ilwiq.FloatType),
            format: (0, $ilwiq.RGBAFormat)
        });
    }
    dispose() {
        this.pmremGenerator.dispose();
        this.copyQuad.dispose();
        this.renderTarget.dispose();
    }
    generate(texture, blur) {
        const { pmremGenerator: pmremGenerator, renderTarget: renderTarget, copyQuad: copyQuad, renderer: renderer } = this;
        // get the pmrem target
        const pmremTarget = pmremGenerator.fromEquirectangular(texture);
        // set up the material
        const { width: width, height: height } = texture.image;
        renderTarget.setSize(width, height);
        copyQuad.material.envMap = pmremTarget.texture;
        copyQuad.material.blur = blur;
        // render
        const prevRenderTarget = renderer.getRenderTarget();
        const prevClear = renderer.autoClear;
        renderer.setRenderTarget(renderTarget);
        renderer.autoClear = true;
        copyQuad.render(renderer);
        renderer.setRenderTarget(prevRenderTarget);
        renderer.autoClear = prevClear;
        // read the data back
        const buffer = new Uint16Array(width * height * 4);
        const readBuffer = new Float32Array(width * height * 4);
        renderer.readRenderTargetPixels(renderTarget, 0, 0, width, height, readBuffer);
        for(let i = 0, l = readBuffer.length; i < l; i++)buffer[i] = (0, $ilwiq.DataUtils).toHalfFloat(readBuffer[i]);
        const result = new (0, $ilwiq.DataTexture)(buffer, width, height, (0, $ilwiq.RGBAFormat), (0, $ilwiq.HalfFloatType));
        result.minFilter = texture.minFilter;
        result.magFilter = texture.magFilter;
        result.wrapS = texture.wrapS;
        result.wrapT = texture.wrapT;
        result.mapping = (0, $ilwiq.EquirectangularReflectionMapping);
        result.needsUpdate = true;
        // dispose of the now unneeded target
        pmremTarget.dispose();
        return result;
    }
}

});
parcelRegister("9fZ6X", function(module, exports) {

$parcel$export(module.exports, "MaterialBase", () => $6bd4eb2914ee2835$export$f1ac3a587b6cbb5d);

var $ilwiq = parcelRequire("ilwiq");
class $6bd4eb2914ee2835$export$f1ac3a587b6cbb5d extends (0, $ilwiq.ShaderMaterial) {
    set needsUpdate(v) {
        super.needsUpdate = true;
        this.dispatchEvent({
            type: "recompilation"
        });
    }
    constructor(shader){
        super(shader);
        for(const key in this.uniforms)Object.defineProperty(this, key, {
            get () {
                return this.uniforms[key].value;
            },
            set (v) {
                this.uniforms[key].value = v;
            }
        });
    }
    // sets the given named define value and sets "needsUpdate" to true if it's different
    setDefine(name, value) {
        if (value === undefined || value === null) {
            if (name in this.defines) {
                delete this.defines[name];
                this.needsUpdate = true;
                return true;
            }
        } else if (this.defines[name] !== value) {
            this.defines[name] = value;
            this.needsUpdate = true;
            return true;
        }
        return false;
    }
}

});

parcelRegister("dUUQZ", function(module, exports) {

$parcel$export(module.exports, "util_functions", () => $a21c9b4177584031$export$fe1d788deccfbee3);
const $a21c9b4177584031$export$fe1d788deccfbee3 = /* glsl */ `

	// TODO: possibly this should be renamed something related to material or path tracing logic

	#ifndef RAY_OFFSET
	#define RAY_OFFSET 1e-4
	#endif

	// adjust the hit point by the surface normal by a factor of some offset and the
	// maximum component-wise value of the current point to accommodate floating point
	// error as values increase.
	vec3 stepRayOrigin( vec3 rayOrigin, vec3 rayDirection, vec3 offset, float dist ) {

		vec3 point = rayOrigin + rayDirection * dist;
		vec3 absPoint = abs( point );
		float maxPoint = max( absPoint.x, max( absPoint.y, absPoint.z ) );
		return point + offset * ( maxPoint + 1.0 ) * RAY_OFFSET;

	}

	// https://github.com/KhronosGroup/glTF/blob/main/extensions/2.0/Khronos/KHR_materials_volume/README.md#attenuation
	vec3 transmissionAttenuation( float dist, vec3 attColor, float attDist ) {

		vec3 ot = - log( attColor ) / attDist;
		return exp( - ot * dist );

	}

	vec3 getHalfVector( vec3 wi, vec3 wo, float eta ) {

		// get the half vector - assuming if the light incident vector is on the other side
		// of the that it's transmissive.
		vec3 h;
		if ( wi.z > 0.0 ) {

			h = normalize( wi + wo );

		} else {

			// Scale by the ior ratio to retrieve the appropriate half vector
			// From Section 2.2 on computing the transmission half vector:
			// https://blog.selfshadow.com/publications/s2015-shading-course/burley/s2015_pbs_disney_bsdf_notes.pdf
			h = normalize( wi + wo * eta );

		}

		h *= sign( h.z );
		return h;

	}

	vec3 getHalfVector( vec3 a, vec3 b ) {

		return normalize( a + b );

	}

	// The discrepancy between interpolated surface normal and geometry normal can cause issues when a ray
	// is cast that is on the top side of the geometry normal plane but below the surface normal plane. If
	// we find a ray like that we ignore it to avoid artifacts.
	// This function returns if the direction is on the same side of both planes.
	bool isDirectionValid( vec3 direction, vec3 surfaceNormal, vec3 geometryNormal ) {

		bool aboveSurfaceNormal = dot( direction, surfaceNormal ) > 0.0;
		bool aboveGeometryNormal = dot( direction, geometryNormal ) > 0.0;
		return aboveSurfaceNormal == aboveGeometryNormal;

	}

	// ray sampling x and z are swapped to align with expected background view
	vec2 equirectDirectionToUv( vec3 direction ) {

		// from Spherical.setFromCartesianCoords
		vec2 uv = vec2( atan( direction.z, direction.x ), acos( direction.y ) );
		uv /= vec2( 2.0 * PI, PI );

		// apply adjustments to get values in range [0, 1] and y right side up
		uv.x += 0.5;
		uv.y = 1.0 - uv.y;
		return uv;

	}

	vec3 equirectUvToDirection( vec2 uv ) {

		// undo above adjustments
		uv.x -= 0.5;
		uv.y = 1.0 - uv.y;

		// from Vector3.setFromSphericalCoords
		float theta = uv.x * 2.0 * PI;
		float phi = uv.y * PI;

		float sinPhi = sin( phi );

		return vec3( sinPhi * cos( theta ), cos( phi ), sinPhi * sin( theta ) );

	}

	// power heuristic for multiple importance sampling
	float misHeuristic( float a, float b ) {

		float aa = a * a;
		float bb = b * b;
		return aa / ( aa + bb );

	}

	// tentFilter from Peter Shirley's 'Realistic Ray Tracing (2nd Edition)' book, pg. 60
	// erichlof/THREE.js-PathTracing-Renderer/
	float tentFilter( float x ) {

		return x < 0.5 ? sqrt( 2.0 * x ) - 1.0 : 1.0 - sqrt( 2.0 - ( 2.0 * x ) );

	}
`;

});


parcelRegister("891vQ", function(module, exports) {

$parcel$export(module.exports, "RGBELoader", () => $5ee05658f4b0e3bf$export$d076a711b55c758a);

var $ilwiq = parcelRequire("ilwiq");
// https://github.com/mrdoob/three.js/issues/5552
// http://en.wikipedia.org/wiki/RGBE_image_format
class $5ee05658f4b0e3bf$export$d076a711b55c758a extends (0, $ilwiq.DataTextureLoader) {
    constructor(manager){
        super(manager);
        this.type = (0, $ilwiq.HalfFloatType);
    }
    // adapted from http://www.graphics.cornell.edu/~bjw/rgbe.html
    parse(buffer) {
        const /* default error routine.  change this to change error handling */ rgbe_read_error = 1, rgbe_write_error = 2, rgbe_format_error = 3, rgbe_memory_error = 4, rgbe_error = function(rgbe_error_code, msg) {
            switch(rgbe_error_code){
                case rgbe_read_error:
                    throw new Error("THREE.RGBELoader: Read Error: " + (msg || ""));
                case rgbe_write_error:
                    throw new Error("THREE.RGBELoader: Write Error: " + (msg || ""));
                case rgbe_format_error:
                    throw new Error("THREE.RGBELoader: Bad File Format: " + (msg || ""));
                default:
                case rgbe_memory_error:
                    throw new Error("THREE.RGBELoader: Memory Error: " + (msg || ""));
            }
        }, /* offsets to red, green, and blue components in a data (float) pixel */ //RGBE_DATA_RED = 0,
        //RGBE_DATA_GREEN = 1,
        //RGBE_DATA_BLUE = 2,
        /* number of floats per pixel, use 4 since stored in rgba image format */ //RGBE_DATA_SIZE = 4,
        /* flags indicating which fields in an rgbe_header_info are valid */ RGBE_VALID_PROGRAMTYPE = 1, RGBE_VALID_FORMAT = 2, RGBE_VALID_DIMENSIONS = 4, NEWLINE = "\n", fgets = function(buffer, lineLimit, consume) {
            const chunkSize = 128;
            lineLimit = !lineLimit ? 1024 : lineLimit;
            let p = buffer.pos, i = -1, len = 0, s = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
            while(0 > (i = chunk.indexOf(NEWLINE)) && len < lineLimit && p < buffer.byteLength){
                s += chunk;
                len += chunk.length;
                p += chunkSize;
                chunk += String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
            }
            if (-1 < i) {
                /*for (i=l-1; i>=0; i--) {
						byteCode = m.charCodeAt(i);
						if (byteCode > 0x7f && byteCode <= 0x7ff) byteLen++;
						else if (byteCode > 0x7ff && byteCode <= 0xffff) byteLen += 2;
						if (byteCode >= 0xDC00 && byteCode <= 0xDFFF) i--; //trail surrogate
					}*/ if (false !== consume) buffer.pos += len + i + 1;
                return s + chunk.slice(0, i);
            }
            return false;
        }, /* minimal header reading.  modify if you want to parse more information */ RGBE_ReadHeader = function(buffer) {
            // regexes to parse header info fields
            const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, // RGBE format header struct
            header = {
                valid: 0,
                /* indicate which fields are valid */ string: "",
                /* the actual header string */ comments: "",
                /* comments found in header */ programtype: "RGBE",
                /* listed at beginning of file to identify it after "#?". defaults to "RGBE" */ format: "",
                /* RGBE format, default 32-bit_rle_rgbe */ gamma: 1.0,
                /* image has already been gamma corrected with given gamma. defaults to 1.0 (no correction) */ exposure: 1.0,
                /* a value of 1.0 in an image corresponds to <exposure> watts/steradian/m^2. defaults to 1.0 */ width: 0,
                height: 0 /* image dimensions, width/height */ 
            };
            let line, match;
            if (buffer.pos >= buffer.byteLength || !(line = fgets(buffer))) rgbe_error(rgbe_read_error, "no header found");
            /* if you want to require the magic token then uncomment the next line */ if (!(match = line.match(magic_token_re))) rgbe_error(rgbe_format_error, "bad initial token");
            header.valid |= RGBE_VALID_PROGRAMTYPE;
            header.programtype = match[1];
            header.string += line + "\n";
            while(true){
                line = fgets(buffer);
                if (false === line) break;
                header.string += line + "\n";
                if ("#" === line.charAt(0)) {
                    header.comments += line + "\n";
                    continue; // comment line
                }
                if (match = line.match(gamma_re)) header.gamma = parseFloat(match[1]);
                if (match = line.match(exposure_re)) header.exposure = parseFloat(match[1]);
                if (match = line.match(format_re)) {
                    header.valid |= RGBE_VALID_FORMAT;
                    header.format = match[1]; //'32-bit_rle_rgbe';
                }
                if (match = line.match(dimensions_re)) {
                    header.valid |= RGBE_VALID_DIMENSIONS;
                    header.height = parseInt(match[1], 10);
                    header.width = parseInt(match[2], 10);
                }
                if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
            }
            if (!(header.valid & RGBE_VALID_FORMAT)) rgbe_error(rgbe_format_error, "missing format specifier");
            if (!(header.valid & RGBE_VALID_DIMENSIONS)) rgbe_error(rgbe_format_error, "missing image size specifier");
            return header;
        }, RGBE_ReadPixels_RLE = function(buffer, w, h) {
            const scanline_width = w;
            if (scanline_width < 8 || scanline_width > 0x7fff || // this file is not run length encoded
            2 !== buffer[0] || 2 !== buffer[1] || buffer[2] & 0x80) // return the flat buffer
            return new Uint8Array(buffer);
            if (scanline_width !== (buffer[2] << 8 | buffer[3])) rgbe_error(rgbe_format_error, "wrong scanline width");
            const data_rgba = new Uint8Array(4 * w * h);
            if (!data_rgba.length) rgbe_error(rgbe_memory_error, "unable to allocate buffer space");
            let offset = 0, pos = 0;
            const ptr_end = 4 * scanline_width;
            const rgbeStart = new Uint8Array(4);
            const scanline_buffer = new Uint8Array(ptr_end);
            let num_scanlines = h;
            // read in each successive scanline
            while(num_scanlines > 0 && pos < buffer.byteLength){
                if (pos + 4 > buffer.byteLength) rgbe_error(rgbe_read_error);
                rgbeStart[0] = buffer[pos++];
                rgbeStart[1] = buffer[pos++];
                rgbeStart[2] = buffer[pos++];
                rgbeStart[3] = buffer[pos++];
                if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) rgbe_error(rgbe_format_error, "bad rgbe scanline format");
                // read each of the four channels for the scanline into the buffer
                // first red, then green, then blue, then exponent
                let ptr = 0, count;
                while(ptr < ptr_end && pos < buffer.byteLength){
                    count = buffer[pos++];
                    const isEncodedRun = count > 128;
                    if (isEncodedRun) count -= 128;
                    if (0 === count || ptr + count > ptr_end) rgbe_error(rgbe_format_error, "bad scanline data");
                    if (isEncodedRun) {
                        // a (encoded) run of the same value
                        const byteValue = buffer[pos++];
                        for(let i = 0; i < count; i++)scanline_buffer[ptr++] = byteValue;
                    //ptr += count;
                    } else {
                        // a literal-run
                        scanline_buffer.set(buffer.subarray(pos, pos + count), ptr);
                        ptr += count;
                        pos += count;
                    }
                }
                // now convert data from buffer into rgba
                // first red, then green, then blue, then exponent (alpha)
                const l = scanline_width; //scanline_buffer.byteLength;
                for(let i = 0; i < l; i++){
                    let off = 0;
                    data_rgba[offset] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 1] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 2] = scanline_buffer[i + off];
                    off += scanline_width; //1;
                    data_rgba[offset + 3] = scanline_buffer[i + off];
                    offset += 4;
                }
                num_scanlines--;
            }
            return data_rgba;
        };
        const RGBEByteToRGBFloat = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2.0, e - 128.0) / 255.0;
            destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
            destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
            destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
            destArray[destOffset + 3] = 1;
        };
        const RGBEByteToRGBHalf = function(sourceArray, sourceOffset, destArray, destOffset) {
            const e = sourceArray[sourceOffset + 3];
            const scale = Math.pow(2.0, e - 128.0) / 255.0;
            // clamping to 65504, the maximum representable value in float16
            destArray[destOffset + 0] = (0, $ilwiq.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 0] * scale, 65504));
            destArray[destOffset + 1] = (0, $ilwiq.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 1] * scale, 65504));
            destArray[destOffset + 2] = (0, $ilwiq.DataUtils).toHalfFloat(Math.min(sourceArray[sourceOffset + 2] * scale, 65504));
            destArray[destOffset + 3] = (0, $ilwiq.DataUtils).toHalfFloat(1);
        };
        const byteArray = new Uint8Array(buffer);
        byteArray.pos = 0;
        const rgbe_header_info = RGBE_ReadHeader(byteArray);
        const w = rgbe_header_info.width, h = rgbe_header_info.height, image_rgba_data = RGBE_ReadPixels_RLE(byteArray.subarray(byteArray.pos), w, h);
        let data, type;
        let numElements;
        switch(this.type){
            case 0, $ilwiq.FloatType:
                numElements = image_rgba_data.length / 4;
                const floatArray = new Float32Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBFloat(image_rgba_data, j * 4, floatArray, j * 4);
                data = floatArray;
                type = (0, $ilwiq.FloatType);
                break;
            case 0, $ilwiq.HalfFloatType:
                numElements = image_rgba_data.length / 4;
                const halfArray = new Uint16Array(numElements * 4);
                for(let j = 0; j < numElements; j++)RGBEByteToRGBHalf(image_rgba_data, j * 4, halfArray, j * 4);
                data = halfArray;
                type = (0, $ilwiq.HalfFloatType);
                break;
            default:
                throw new Error("THREE.RGBELoader: Unsupported type: " + this.type);
        }
        return {
            width: w,
            height: h,
            data: data,
            header: rgbe_header_info.string,
            gamma: rgbe_header_info.gamma,
            exposure: rgbe_header_info.exposure,
            type: type
        };
    }
    setDataType(value) {
        this.type = value;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        function onLoadCallback(texture, texData) {
            switch(texture.type){
                case 0, $ilwiq.FloatType:
                case 0, $ilwiq.HalfFloatType:
                    texture.colorSpace = (0, $ilwiq.LinearSRGBColorSpace);
                    texture.minFilter = (0, $ilwiq.LinearFilter);
                    texture.magFilter = (0, $ilwiq.LinearFilter);
                    texture.generateMipmaps = false;
                    texture.flipY = true;
                    break;
            }
            if (onLoad) onLoad(texture, texData);
        }
        return super.load(url, onLoadCallback, onProgress, onError);
    }
}

});

parcelRegister("1EdOY", function(module, exports) {

$parcel$export(module.exports, "generateRadialFloorTexture", () => $13343f7d1c4dd8ec$export$92750171fb06fc99);

var $ilwiq = parcelRequire("ilwiq");
function $13343f7d1c4dd8ec$export$92750171fb06fc99(dim) {
    const data = new Uint8Array(dim * dim * 4);
    for(let x = 0; x < dim; x++)for(let y = 0; y < dim; y++){
        const xNorm = x / (dim - 1);
        const yNorm = y / (dim - 1);
        const xCent = 2.0 * (xNorm - 0.5);
        const yCent = 2.0 * (yNorm - 0.5);
        let a = Math.max(Math.min(1.0 - Math.sqrt(xCent ** 2 + yCent ** 2), 1.0), 0.0);
        a = a ** 2;
        a = a * 1.5;
        a = Math.min(a, 1.0);
        const i = y * dim + x;
        data[i * 4 + 0] = 255;
        data[i * 4 + 1] = 255;
        data[i * 4 + 2] = 255;
        data[i * 4 + 3] = a * 255;
    }
    const tex = new $ilwiq.DataTexture(data, dim, dim);
    tex.format = $ilwiq.RGBAFormat;
    tex.type = $ilwiq.UnsignedByteType;
    tex.minFilter = $ilwiq.LinearFilter;
    tex.magFilter = $ilwiq.LinearFilter;
    tex.wrapS = $ilwiq.RepeatWrapping;
    tex.wrapT = $ilwiq.RepeatWrapping;
    tex.needsUpdate = true;
    return tex;
}

});

parcelRegister("cE5k3", function(module, exports) {

$parcel$export(module.exports, "getScaledSettings", () => $934d596524c3e5a8$export$5bc756cb1c628b75);
function $934d596524c3e5a8$export$5bc756cb1c628b75() {
    let tiles = 3;
    let renderScale = Math.max(1 / window.devicePixelRatio, 0.5);
    // adjust performance parameters for mobile
    const aspectRatio = window.innerWidth / window.innerHeight;
    if (aspectRatio < 0.65) {
        tiles = 4;
        renderScale = 0.5 / window.devicePixelRatio;
    }
    return {
        tiles: tiles,
        renderScale: renderScale
    };
}

});

parcelRegister("e2Pv4", function(module, exports) {

$parcel$export(module.exports, "LoaderElement", () => $a399336cf50451da$export$c2252eb3bc5ad0b7);
let $a399336cf50451da$var$_styleElement;
function $a399336cf50451da$var$initializeStyles() {
    if ($a399336cf50451da$var$_styleElement) return;
    $a399336cf50451da$var$_styleElement = document.createElement("style");
    $a399336cf50451da$var$_styleElement.textContent = /* css */ `

		.loader-container, .description {
			position: absolute;
			width: 100%;
			font-family: 'Courier New', Courier, monospace;
			color: white;
			font-weight: light;
			align-items: flex-start;
			font-size: 14px;
			pointer-events: none;
			user-select: none;
		}

		.loader-container {
			display: flex;
			flex-direction: column;
			bottom: 0;
		}

		.description {
			top: 0;
			width: 100%;
			text-align: center;
			padding: 5px 0;
		}

		.loader-container .bar {
			height: 2px;
			background: white;
			width: 100%;
		}

		.loader-container .credits,
		.loader-container .samples,
		.loader-container .percentage {
			padding: 5px;
			margin: 0 0 1px 1px;
			background: rgba( 0, 0, 0, 0.2 );
			border-radius: 2px;
			display: inline-block;
		}

		.loader-container:not(.loading) .bar,
		.loader-container:not(.loading) .percentage,
		.loader-container.loading .credits,
		.loader-container.loading .samples,
		.loader-container .credits:empty {
			display: none;
		}

		.loader-container .credits a,
		.loader-container .credits,
		.loader-container .samples {
			color: rgba( 255, 255, 255, 0.75 );
		}
	`;
    document.head.appendChild($a399336cf50451da$var$_styleElement);
}
class $a399336cf50451da$export$c2252eb3bc5ad0b7 {
    constructor(){
        $a399336cf50451da$var$initializeStyles();
        const container = document.createElement("div");
        container.classList.add("loader-container");
        const percentageEl = document.createElement("div");
        percentageEl.classList.add("percentage");
        container.appendChild(percentageEl);
        const samplesEl = document.createElement("div");
        samplesEl.classList.add("samples");
        container.appendChild(samplesEl);
        const creditsEl = document.createElement("div");
        creditsEl.classList.add("credits");
        container.appendChild(creditsEl);
        const loaderBarEl = document.createElement("div");
        loaderBarEl.classList.add("bar");
        container.appendChild(loaderBarEl);
        const descriptionEl = document.createElement("div");
        descriptionEl.classList.add("description");
        container.appendChild(descriptionEl);
        this._description = descriptionEl;
        this._loaderBar = loaderBarEl;
        this._percentage = percentageEl;
        this._credits = creditsEl;
        this._samples = samplesEl;
        this._container = container;
        this.setPercentage(0);
    }
    attach(container) {
        container.appendChild(this._container);
        container.appendChild(this._description);
    }
    setPercentage(perc) {
        this._loaderBar.style.width = `${perc * 100}%`;
        if (perc === 0) this._percentage.innerText = "Loading...";
        else this._percentage.innerText = `${(perc * 100).toFixed(0)}%`;
        if (perc >= 1) this._container.classList.remove("loading");
        else this._container.classList.add("loading");
    }
    setSamples(count, compiling = false) {
        if (compiling) this._samples.innerText = "compiling shader...";
        else this._samples.innerText = `${Math.floor(count)} samples`;
    }
    setCredits(credits) {
        this._credits.innerHTML = credits;
    }
    setDescription(description) {
        this._description.innerHTML = description;
    }
}

});

parcelRegister("fYvb1", function(module, exports) {

$parcel$export(module.exports, "math_functions", () => $ba14a4aaa0cde19b$export$98323a006d35be35);
const $ba14a4aaa0cde19b$export$98323a006d35be35 = /* glsl */ `

	// Fast arccos approximation used to remove banding artifacts caused by numerical errors in acos.
	// This is a cubic Lagrange interpolating polynomial for x = [-1, -1/2, 0, 1/2, 1].
	// For more information see: https://github.com/gkjohnson/three-gpu-pathtracer/pull/171#issuecomment-1152275248
	float acosApprox( float x ) {

		x = clamp( x, -1.0, 1.0 );
		return ( - 0.69813170079773212 * x * x - 0.87266462599716477 ) * x + 1.5707963267948966;

	}

	// An acos with input values bound to the range [-1, 1].
	float acosSafe( float x ) {

		return acos( clamp( x, -1.0, 1.0 ) );

	}

	float saturateCos( float val ) {

		return clamp( val, 0.001, 1.0 );

	}

	float square( float t ) {

		return t * t;

	}

	vec2 square( vec2 t ) {

		return t * t;

	}

	vec3 square( vec3 t ) {

		return t * t;

	}

	vec4 square( vec4 t ) {

		return t * t;

	}

	vec2 rotateVector( vec2 v, float t ) {

		float ac = cos( t );
		float as = sin( t );
		return vec2(
			v.x * ac - v.y * as,
			v.x * as + v.y * ac
		);

	}

	// forms a basis with the normal vector as Z
	mat3 getBasisFromNormal( vec3 normal ) {

		vec3 other;
		if ( abs( normal.x ) > 0.5 ) {

			other = vec3( 0.0, 1.0, 0.0 );

		} else {

			other = vec3( 1.0, 0.0, 0.0 );

		}

		vec3 ortho = normalize( cross( normal, other ) );
		vec3 ortho2 = normalize( cross( normal, ortho ) );
		return mat3( ortho2, ortho, normal );

	}

`;

});

parcelRegister("8keuf", function(module, exports) {

$parcel$export(module.exports, "ggx_functions", () => $60fb6dc3c6495c33$export$4c711108e2e8ef5e);
const $60fb6dc3c6495c33$export$4c711108e2e8ef5e = /* glsl */ `

	// The GGX functions provide sampling and distribution information for normals as output so
	// in order to get probability of scatter direction the half vector must be computed and provided.
	// [0] https://www.cs.cornell.edu/~srm/publications/EGSR07-btdf.pdf
	// [1] https://hal.archives-ouvertes.fr/hal-01509746/document
	// [2] http://jcgt.org/published/0007/04/01/
	// [4] http://jcgt.org/published/0003/02/03/

	// trowbridge-reitz === GGX === GTR

	vec3 ggxDirection( vec3 incidentDir, vec2 roughness, vec2 uv ) {

		// TODO: try GGXVNDF implementation from reference [2], here. Needs to update ggxDistribution
		// function below, as well

		// Implementation from reference [1]
		// stretch view
		vec3 V = normalize( vec3( roughness * incidentDir.xy, incidentDir.z ) );

		// orthonormal basis
		vec3 T1 = ( V.z < 0.9999 ) ? normalize( cross( V, vec3( 0.0, 0.0, 1.0 ) ) ) : vec3( 1.0, 0.0, 0.0 );
		vec3 T2 = cross( T1, V );

		// sample point with polar coordinates (r, phi)
		float a = 1.0 / ( 1.0 + V.z );
		float r = sqrt( uv.x );
		float phi = ( uv.y < a ) ? uv.y / a * PI : PI + ( uv.y - a ) / ( 1.0 - a ) * PI;
		float P1 = r * cos( phi );
		float P2 = r * sin( phi ) * ( ( uv.y < a ) ? 1.0 : V.z );

		// compute normal
		vec3 N = P1 * T1 + P2 * T2 + V * sqrt( max( 0.0, 1.0 - P1 * P1 - P2 * P2 ) );

		// unstretch
		N = normalize( vec3( roughness * N.xy, max( 0.0, N.z ) ) );

		return N;

	}

	// Below are PDF and related functions for use in a Monte Carlo path tracer
	// as specified in Appendix B of the following paper
	// See equation (34) from reference [0]
	float ggxLamda( float theta, float roughness ) {

		float tanTheta = tan( theta );
		float tanTheta2 = tanTheta * tanTheta;
		float alpha2 = roughness * roughness;

		float numerator = - 1.0 + sqrt( 1.0 + alpha2 * tanTheta2 );
		return numerator / 2.0;

	}

	// See equation (34) from reference [0]
	float ggxShadowMaskG1( float theta, float roughness ) {

		return 1.0 / ( 1.0 + ggxLamda( theta, roughness ) );

	}

	// See equation (125) from reference [4]
	float ggxShadowMaskG2( vec3 wi, vec3 wo, float roughness ) {

		float incidentTheta = acos( wi.z );
		float scatterTheta = acos( wo.z );
		return 1.0 / ( 1.0 + ggxLamda( incidentTheta, roughness ) + ggxLamda( scatterTheta, roughness ) );

	}

	// See equation (33) from reference [0]
	float ggxDistribution( vec3 halfVector, float roughness ) {

		float a2 = roughness * roughness;
		a2 = max( EPSILON, a2 );
		float cosTheta = halfVector.z;
		float cosTheta4 = pow( cosTheta, 4.0 );

		if ( cosTheta == 0.0 ) return 0.0;

		float theta = acosSafe( halfVector.z );
		float tanTheta = tan( theta );
		float tanTheta2 = pow( tanTheta, 2.0 );

		float denom = PI * cosTheta4 * pow( a2 + tanTheta2, 2.0 );
		return ( a2 / denom );

	}

	// See equation (3) from reference [2]
	float ggxPDF( vec3 wi, vec3 halfVector, float roughness ) {

		float incidentTheta = acos( wi.z );
		float D = ggxDistribution( halfVector, roughness );
		float G1 = ggxShadowMaskG1( incidentTheta, roughness );

		return D * G1 * max( 0.0, dot( wi, halfVector ) ) / wi.z;

	}

`;

});


var $ilwiq = parcelRequire("ilwiq");

var $7lx9d = parcelRequire("7lx9d");

var $5Rd1x = parcelRequire("5Rd1x");

var $eLX8K = parcelRequire("eLX8K");
var $8mHfG = parcelRequire("8mHfG");

var $891vQ = parcelRequire("891vQ");

var $kp7Te = parcelRequire("kp7Te");

var $jiuw3 = parcelRequire("jiuw3");

var $1EdOY = parcelRequire("1EdOY");

var $cE5k3 = parcelRequire("cE5k3");

var $e2Pv4 = parcelRequire("e2Pv4");
const $f06a0a82aa9331ef$var$ENV_URL = "https://raw.githubusercontent.com/gkjohnson/3d-demo-data/master/hdri/aristea_wreck_puresky_2k.hdr";
const $f06a0a82aa9331ef$var$MORPH_URL = "https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/models/gltf/RobotExpressive/RobotExpressive.glb";
const $f06a0a82aa9331ef$var$SKINNED_URL = "https://raw.githubusercontent.com/gkjohnson/3d-demo-data/main/models/trex/scene.gltf";
const $f06a0a82aa9331ef$var$CREDITS = "Model by DailyArt on Sketchfab";
const $f06a0a82aa9331ef$var$DESCRIPTION = "Rendering deformable geometry with path tracing.";
let $f06a0a82aa9331ef$var$pathTracer, $f06a0a82aa9331ef$var$renderer, $f06a0a82aa9331ef$var$controls, $f06a0a82aa9331ef$var$camera, $f06a0a82aa9331ef$var$scene, $f06a0a82aa9331ef$var$clock;
let $f06a0a82aa9331ef$var$mixer, $f06a0a82aa9331ef$var$mixerAction;
let $f06a0a82aa9331ef$var$loader;
let $f06a0a82aa9331ef$var$counter = 0;
const $f06a0a82aa9331ef$var$params = {
    bounces: 5,
    samplesPerFrame: 1,
    renderScale: 1 / window.devicePixelRatio,
    tiles: 1,
    autoPause: true,
    pause: false,
    continuous: false,
    stableNoise: false,
    ...(0, $cE5k3.getScaledSettings)()
};
$f06a0a82aa9331ef$var$init();
async function $f06a0a82aa9331ef$var$init() {
    $f06a0a82aa9331ef$var$loader = new (0, $e2Pv4.LoaderElement)();
    $f06a0a82aa9331ef$var$loader.setDescription($f06a0a82aa9331ef$var$DESCRIPTION);
    $f06a0a82aa9331ef$var$loader.attach(document.body);
    // renderer
    $f06a0a82aa9331ef$var$renderer = new (0, $ilwiq.WebGLRenderer)({
        antialias: true
    });
    $f06a0a82aa9331ef$var$renderer.toneMapping = (0, $ilwiq.ACESFilmicToneMapping);
    document.body.appendChild($f06a0a82aa9331ef$var$renderer.domElement);
    // path tracer
    $f06a0a82aa9331ef$var$pathTracer = new (0, $8mHfG.WebGLPathTracer)($f06a0a82aa9331ef$var$renderer);
    $f06a0a82aa9331ef$var$pathTracer.multipleImportanceSampling = false;
    $f06a0a82aa9331ef$var$pathTracer.tiles.set($f06a0a82aa9331ef$var$params.tiles, $f06a0a82aa9331ef$var$params.tiles);
    $f06a0a82aa9331ef$var$pathTracer.filterGlossyFactor = 0.25;
    $f06a0a82aa9331ef$var$pathTracer.minSamples = 1;
    $f06a0a82aa9331ef$var$pathTracer.renderDelay = 0;
    $f06a0a82aa9331ef$var$pathTracer.fadeDuration = 0;
    // scene
    $f06a0a82aa9331ef$var$scene = new (0, $ilwiq.Scene)();
    // camera
    $f06a0a82aa9331ef$var$camera = new (0, $ilwiq.PerspectiveCamera)(75, window.innerWidth / window.innerHeight, 0.025, 500);
    $f06a0a82aa9331ef$var$camera.position.set(5.5, 3.5, 7.5);
    // controls
    $f06a0a82aa9331ef$var$controls = new (0, $5Rd1x.OrbitControls)($f06a0a82aa9331ef$var$camera, $f06a0a82aa9331ef$var$renderer.domElement);
    $f06a0a82aa9331ef$var$camera.lookAt($f06a0a82aa9331ef$var$controls.target);
    $f06a0a82aa9331ef$var$controls.addEventListener("change", ()=>$f06a0a82aa9331ef$var$pathTracer.updateCamera());
    $f06a0a82aa9331ef$var$controls.update();
    // clock
    $f06a0a82aa9331ef$var$clock = new (0, $ilwiq.Clock)();
    // load assets
    const modelUrl = window.location.hash === "#morphtarget" ? $f06a0a82aa9331ef$var$MORPH_URL : $f06a0a82aa9331ef$var$SKINNED_URL;
    const [envTexture, gltf] = await Promise.all([
        new (0, $891vQ.RGBELoader)().loadAsync($f06a0a82aa9331ef$var$ENV_URL),
        new (0, $7lx9d.GLTFLoader)().setMeshoptDecoder((0, $kp7Te.MeshoptDecoder)).loadAsync(modelUrl)
    ]);
    // update env map
    const generator = new (0, $eLX8K.BlurredEnvMapGenerator)($f06a0a82aa9331ef$var$renderer);
    const blurredTex = generator.generate(envTexture, 0.1);
    $f06a0a82aa9331ef$var$scene.background = blurredTex;
    $f06a0a82aa9331ef$var$scene.environment = blurredTex;
    generator.dispose();
    // animations
    const animations = gltf.animations;
    $f06a0a82aa9331ef$var$mixer = new (0, $ilwiq.AnimationMixer)(gltf.scene);
    $f06a0a82aa9331ef$var$mixerAction = $f06a0a82aa9331ef$var$mixer.clipAction(animations[0]);
    $f06a0a82aa9331ef$var$mixerAction.play();
    $f06a0a82aa9331ef$var$mixerAction.paused = $f06a0a82aa9331ef$var$params.pause;
    // initialize scene
    $f06a0a82aa9331ef$var$scene.add(gltf.scene);
    const floorTex = (0, $1EdOY.generateRadialFloorTexture)(2048);
    const floorPlane = new (0, $ilwiq.Mesh)(new (0, $ilwiq.PlaneGeometry)(), new (0, $ilwiq.MeshStandardMaterial)({
        map: floorTex,
        transparent: true,
        color: 0xdddddd,
        roughness: 0.15,
        metalness: 1.0
    }));
    floorPlane.scale.setScalar(50);
    floorPlane.rotation.x = -Math.PI / 2;
    floorPlane.position.y = 0.075;
    $f06a0a82aa9331ef$var$scene.add(floorPlane);
    // initial generation
    $f06a0a82aa9331ef$var$pathTracer.setScene($f06a0a82aa9331ef$var$scene, $f06a0a82aa9331ef$var$camera);
    $f06a0a82aa9331ef$var$loader.setPercentage(1);
    $f06a0a82aa9331ef$var$loader.setCredits($f06a0a82aa9331ef$var$CREDITS);
    $f06a0a82aa9331ef$var$onResize();
    window.addEventListener("resize", $f06a0a82aa9331ef$var$onResize);
    // gui
    const gui = new (0, $jiuw3.GUI)();
    gui.add($f06a0a82aa9331ef$var$params, "tiles", 1, 4, 1).onChange((value)=>{
        $f06a0a82aa9331ef$var$pathTracer.tiles.set(value, value);
    });
    gui.add($f06a0a82aa9331ef$var$params, "bounces", 1, 10, 1).onChange($f06a0a82aa9331ef$var$regenerateScene);
    gui.add($f06a0a82aa9331ef$var$params, "renderScale", 0.1, 1).onChange((v)=>{
        $f06a0a82aa9331ef$var$pathTracer.renderScale = v;
        $f06a0a82aa9331ef$var$pathTracer.reset();
    });
    gui.add($f06a0a82aa9331ef$var$params, "autoPause").listen();
    gui.add($f06a0a82aa9331ef$var$params, "pause").onChange((v)=>{
        $f06a0a82aa9331ef$var$params.autoPause = false;
        $f06a0a82aa9331ef$var$setPause(v);
    }).listen();
    gui.add($f06a0a82aa9331ef$var$params, "continuous").onChange(()=>{
        $f06a0a82aa9331ef$var$params.autoPause = false;
    });
    gui.add($f06a0a82aa9331ef$var$params, "stableNoise").onChange((v)=>{
        $f06a0a82aa9331ef$var$pathTracer.stableNoise = v;
    });
    $f06a0a82aa9331ef$var$animate();
}
function $f06a0a82aa9331ef$var$setPause(v) {
    $f06a0a82aa9331ef$var$mixerAction.paused = v;
    $f06a0a82aa9331ef$var$params.pause = v;
    if (v) $f06a0a82aa9331ef$var$regenerateScene();
}
function $f06a0a82aa9331ef$var$onResize() {
    $f06a0a82aa9331ef$var$renderer.setSize(window.innerWidth, window.innerHeight);
    $f06a0a82aa9331ef$var$renderer.setPixelRatio(window.devicePixelRatio);
    $f06a0a82aa9331ef$var$camera.aspect = window.innerWidth / window.innerHeight;
    $f06a0a82aa9331ef$var$camera.updateProjectionMatrix();
    $f06a0a82aa9331ef$var$pathTracer.updateCamera();
}
function $f06a0a82aa9331ef$var$regenerateScene() {
    $f06a0a82aa9331ef$var$pathTracer.bounces = $f06a0a82aa9331ef$var$params.bounces;
    $f06a0a82aa9331ef$var$pathTracer.setScene($f06a0a82aa9331ef$var$scene, $f06a0a82aa9331ef$var$camera);
}
function $f06a0a82aa9331ef$var$animate() {
    requestAnimationFrame($f06a0a82aa9331ef$var$animate);
    // step the animation forward
    const delta = Math.min($f06a0a82aa9331ef$var$clock.getDelta(), 0.03);
    $f06a0a82aa9331ef$var$mixer.update(delta);
    if ($f06a0a82aa9331ef$var$params.autoPause) {
        // auto pause the animation
        $f06a0a82aa9331ef$var$counter += delta;
        if (!$f06a0a82aa9331ef$var$params.pause && $f06a0a82aa9331ef$var$counter >= 2.5 || $f06a0a82aa9331ef$var$params.pause && $f06a0a82aa9331ef$var$counter >= 5) {
            $f06a0a82aa9331ef$var$setPause(!$f06a0a82aa9331ef$var$params.pause);
            $f06a0a82aa9331ef$var$counter = 0;
        }
    } else $f06a0a82aa9331ef$var$counter = 0;
    $f06a0a82aa9331ef$var$pathTracer.dynamicLowRes = $f06a0a82aa9331ef$var$params.continuous;
    if (!$f06a0a82aa9331ef$var$params.pause && !$f06a0a82aa9331ef$var$params.continuous) {
        $f06a0a82aa9331ef$var$renderer.render($f06a0a82aa9331ef$var$scene, $f06a0a82aa9331ef$var$camera);
        $f06a0a82aa9331ef$var$loader.setSamples(0, $f06a0a82aa9331ef$var$pathTracer.isCompiling);
    } else {
        // if we're continuously path tracing then update the scene
        if (!$f06a0a82aa9331ef$var$params.pause && $f06a0a82aa9331ef$var$params.continuous) $f06a0a82aa9331ef$var$regenerateScene();
        $f06a0a82aa9331ef$var$pathTracer.renderSample();
        $f06a0a82aa9331ef$var$loader.setSamples($f06a0a82aa9331ef$var$pathTracer.samples, $f06a0a82aa9331ef$var$pathTracer.isCompiling);
    }
}


//# sourceMappingURL=skinnedMesh.49d8c0b2.js.map
